import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { ACCESS_TOKEN_KEY } from '@/shared/constants/header-key';
import { api, getErrorMessage } from '../api/api';

export function useSignOut() {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async () => {
      return await api.post('auth/signout');
    },
    onSuccess: () => {
      // localStorage에서 토큰 삭제
      if (typeof window !== 'undefined') {
        window.localStorage.removeItem(ACCESS_TOKEN_KEY);
      }

      // 로그인 페이지로 리다이렉트
      navigate('/signin');
    },
    onError: async (error) => {
      const errorMessage = await getErrorMessage(error);
      toast.error(errorMessage);
    },
  });
}
